import axios from "axios";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import NotFoundModel from "../../Components/NotFoundModel";
import {
  Bg,
  BoxContainer,
  Button,
  Underline,
} from "../../Components/Styles/PageStyles";
import Config from "../../Config";
import Images from "../../Images";
import { toast } from "react-toastify";
import TenantDetailForm from "../../Components/Beds/TenantDetailForm";

const BedsDetails = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState();
  const [apiData, setApiData] = useState();
  const [editData, setEditData] = useState(false);

  const fetchData = async () => {
    const body = new FormData();
    return await axios.post(`${Config.apiUrl}/getbeddetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onDataSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) error = true;
    setApiData(res.data);
  };

  const onDataError = (data) => {};

  useEffect(() => {
    const handler = setTimeout(() => {
      DataMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  const {
    isLoading: isDataLoading,
    mutate: DataMutate,
    error,
    data,
  } = useMutation(fetchData, {
    onSuccess: onDataSuccess,
    onError: onDataError,
  });

  const editDataPost = async (values) => {
    const body = new FormData();

    Object.keys(values).forEach((i) => body.append(i, values[i]));

    return await axios.post(`${Config.apiUrl}/editbeddetails`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    setApiData(data?.data);
    // DataMutate();
    setEditData(false);
  };

  const onEditError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    // DataMutate();
    setEditData(false);
  };

  const { isLoading: editIsLoading, mutate: editMutate } = useMutation(
    editDataPost,
    {
      onSuccess: onEditSuccess,
      onError: onEditError,
    }
  );
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>Bed Details</Title>
              <Underline />
            </div>
          </div>
          {!error && !isDataLoading && data && (
            <TableWrapper>
              <TenantDetailForm
                ApiData={apiData?.data}
                setSelectedData={setSelectedData}
                userType={user.userType}
                selectedData={selectedData}
                setEditData={setEditData}
              />
              {(error || apiData?.msg == "No data found") && !isDataLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}

          {isDataLoading && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};
const Title = tw.h1`text-xl w-full text-gray-800 whitespace-nowrap font-medium flex justift-center`;
const TableWrapper = tw.h1`my-8 border  bg-white rounded-md `;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;

export default BedsDetails;
